import { IEntity } from '@/base/core/iEntity';
export class ContentModel implements IEntity {
    currentSiteId!: any;
    originalUrl!: any;
    title!: any;
    forms!: any;
    postedField!: any;
    autopostback!: any;
}